import { registerComponent } from '@gig/magic-common';
import { SowPrompterComponent } from './sow-prompter.js';

var SowPrompter = registerComponent(SowPrompterComponent);

export { SowPrompter };
